module.exports = __webpack_public_path__ + "images/aa51346.png";